import { TherapistAction } from 'src/redux/actions/constant';

const initialState: object = {
  response: null,
  loading: false,
  error: null,
  success: false,
};

export const getRecurringAppointmentCountReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TherapistAction.GET_RECURRING_APPOINTMENT_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case TherapistAction.GET_RECURRING_APPOINTMENT_COUNT_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
        error: null,
        success: true,
      };
    case TherapistAction.GET_RECURRING_APPOINTMENT_COUNT_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        error: action.payload,
        success: false,
      };
    case TherapistAction.GET_RECURRING_APPOINTMENT_COUNT_RESET:
      return initialState;
    default:
      return state;
  }
};
